import { Box } from "@mui/material"
import { styled } from "@mui/system"

const FlexBetweenBox = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "no-wrap",
  padding: "0.25rem"
})

export default FlexBetweenBox